class Stats {
  constructor(data = {}) {
    this.total_users = data.total_users ?? 0;
    this.total_leads = data.total_leads ?? 0;
    this.total_properties = data.total_properties ?? 0;
    this.total_compounds = data.total_compounds ?? 0;
    this.total_developers = data.total_developers ?? 0;
    this.leads_by_stage = data.leads_by_stage ?? {
      cil: 0,
      eoi: 0,
      reservation: 0,
      sale_claim: 0
    };
    this.recent_users = data.recent_users ?? [];
    this.recent_leads = data.recent_leads ?? [];
  }
}

export default Stats;
